import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { trackProductSetReviewsPagination } from '../../actions/products';
import { loadReviews } from '../../actions/reviews';
import { trackFilterReviews } from '../../actions/tracking';
import { getProductReviews } from '../../utils/selectors';

import ProductDetailReviews from './ProductDetailReviews';

export function mapStateToProps(state, ownProps) {
  return {
    reviews: getProductReviews(state, ownProps),
    reviewSortCategory: state.reviews.reviewSortCategory,
    selectedProductSize: state.reviews.selectedProductSize,
    tld: state.domain.tld,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadReviews,
      trackFilterReviews,
      trackProductSetReviewsPagination,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDetailReviews);
